<template>
  <div v-if="enabled" ref="root" class="cursor" :class="{ 'is-hidden': state.hidden || !visible }" aria-hidden="true">
    <div ref="ball" class="cursor__ball">
      <span class="cursor__label">{{ state.label }}</span>
    </div>
  </div>
</template>

<script>
import { gsap, isTouchDevice, prefersReducedMotion } from '@/animations/gsap'
import { cursor } from '@/animations/cursor'

export default {
  name: 'CustomCursor',
  data() {
    return {
      enabled: !isTouchDevice() && !prefersReducedMotion(),
      visible: false,
      state: cursor
    }
  },
  watch: {
    'state.label'(label) {
      if (!this.$refs.ball) return
      gsap.to(this.$refs.ball, { scale: label ? 1 : 0.12, duration: 0.5, ease: 'expo.out' })
    }
  },
  mounted() {
    if (!this.enabled) return
    document.documentElement.classList.add('has-custom-cursor')
    gsap.set(this.$refs.ball, { scale: 0.12 })
    this.moveX = gsap.quickTo(this.$refs.root, 'x', { duration: 0.35, ease: 'power3.out' })
    this.moveY = gsap.quickTo(this.$refs.root, 'y', { duration: 0.35, ease: 'power3.out' })
    window.addEventListener('pointermove', this.onMove)
    document.addEventListener('pointerleave', this.onLeaveWindow)
  },
  beforeDestroy() {
    document.documentElement.classList.remove('has-custom-cursor')
    window.removeEventListener('pointermove', this.onMove)
    document.removeEventListener('pointerleave', this.onLeaveWindow)
  },
  methods: {
    onMove(e) {
      if (e.pointerType !== 'mouse') return
      if (!this.visible) {
        gsap.set(this.$refs.root, { x: e.clientX, y: e.clientY })
        this.visible = true
      }
      this.moveX(e.clientX)
      this.moveY(e.clientY)
    },
    onLeaveWindow() {
      this.visible = false
    }
  }
}
</script>

<style scoped>
.cursor {
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--z-cursor);
  pointer-events: none;
  mix-blend-mode: difference;
  transition: opacity 0.3s ease;
}

.cursor.is-hidden {
  opacity: 0;
}

.cursor__ball {
  position: absolute;
  width: 88px;
  height: 88px;
  margin: -44px 0 0 -44px;
  border-radius: 50%;
  background: #fff;
  display: grid;
  place-items: center;
}

.cursor__label {
  color: #000;
  font-size: 0.72rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}
</style>
